import { withRouter } from 'react-router-dom';

import Megatable from '../../base/megatable/megatable';
import './article-megatable.scss';
import './recommendation-megatable.scss';

class MerchantArticleMegatable extends Megatable {
  constructor(props) {
    /*
     * Since megatable constructor must be called first (cannot define
     * properties on 'this' before super is called), we must pass the statType
     * with super.
     */
    const statType = 'merchantArticle';
    const tableName = 'Stories';
    const orgType = 'merchants';
    const disableEditUrl = false;

    super(props, statType, tableName, disableEditUrl, orgType);
  }
}

class MerchantRecommendationMegatable extends Megatable {
  constructor(props) {
    /*
     * Since megatable constructor must be called first (cannot define
     * properties on 'this' before super is called), we must pass the statType
     * with super.
     */
    const statType = 'merchantRecommendation';
    const tableName = 'Recommended Products';
    const orgType = 'merchants';
    const disableEditUrl = true;

    super(props, statType, tableName, disableEditUrl, orgType);
  }
}

class MerchantTopPublisherMegatable extends Megatable {
  constructor(props) {
    const statType = 'merchantTopPublisher';
    const tableName = 'Publishers';
    const orgType = 'merchants';
    const disableEditUrl = true;

    super(props, statType, tableName, disableEditUrl, orgType);
  }
}

const MerchArticleMegatable = withRouter(MerchantArticleMegatable);
const MerchRecommendationMegatable = withRouter(MerchantRecommendationMegatable);
const MerchTopPublisherMegatable = withRouter(MerchantTopPublisherMegatable);

export {
  /* Components */
  MerchArticleMegatable,
  MerchRecommendationMegatable,
  MerchTopPublisherMegatable,
};
